<template>
  <div class="pwc-app-home">
    <keep-alive>
      <component
        :is="cCurrent"
        class="pwc-app-content"
        :events="cEventList"
        :banner="false"
        :upload-avatar="handleUpdateAvatar"
        @go:event:detail="handleGoEventDetail"
        @go:qrcode="handleGoQRcode"
        @go:registered="handleGoRegistered"
        @go:approved="handleGoApproved"
        @go:logout="handleGoLogout"
        @go:coupon="handleGoCoupon"
        @edit:info="handleGoEditInfo"
        @preview="handleGoPreview"
        @add="handleGoAdd"
        @register="handleRegister"
      />
    </keep-alive>
    <van-tabbar v-model="active" class="pwc-app-bar">
      <van-tabbar-item v-if="cEventList.length>0" name="event" icon="flag-o">近期活动</van-tabbar-item>
      <van-tabbar-item v-if="cProductList.length>0" name="document" icon="description">项目申请</van-tabbar-item>
      <van-tabbar-item name="self" icon="user-o">我的信息</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import EventList from '@/components/EventList/mobile'
import ProductList from '@/components/ProductList/mobile'
import SelfCenter from '@/components/SelfCenter/mobile'
import { Tabbar, TabbarItem } from 'vant'

import { logic } from '../common/mixin/logic'

export default {
  provide() {
    return {
      home: this
    }
  },
  components: {
    VanTabbar: Tabbar,
    VanTabbarItem: TabbarItem,
    /* eslint-disable vue/no-unused-components */
    EventList,
    ProductList,
    SelfCenter
  },
  mixins: [logic]
}
</script>

<style lang="scss"  src="./index.scss" scoped />
